import { gql } from "@apollo/client";

export const confirmWsPay = gql`mutation SetWsPayResponse($id: String!, $input: WsPayResponseInput!) {
  setWsPayResponse(id: $id, input: $input)
}
`;
